import React, { useState, useEffect } from "react"
import Bacon from "baconjs"
import { compose, filter, call, map, apply, flip, partial, merge, defaultTo,
  always, curry, reduce, keys, evolve, assoc, toPairs, nth,
  omit } from 'ramda'

const fapply = flip(apply, [])

export function useObservable(observable) {
  const [ value, setValue ] = useState(null)
  useEffect( () => observable.onValue( (v) => setValue(v) ) )
  return value
}

export class BaconComponent extends React.Component {
  constructor(props) {
    super(props)
    this._observeStreams = []
  }

  onStreamsReady() { }

  getStateStreams(props) { return {} }
  getOptStateStreams(props) { return {} }

  componentDidMount() {
    const reqState = this.getStateStreams(this.props)
    const reqOptState = this.getOptStateStreams(this.props)

    this.setState({ __ready: keys(reqState).length == 0 })

    this._streamsToState(reqState, true)
    this._streamsToState(reqOptState, false);
  }

  _streamsToState(streams, hold) {
    if (keys(streams).length > 0) {
      const s = Bacon
        .combineTemplate(streams)

      const onValue = (state) => {
        if (!this._streamsAlreadyDone) {
          // if (__DEV__) console.info(`Stream:${this.constructor.displayName} resolved`, state)
          this._streamsAlreadyDone = true
          this.setState(state, this.onStreamsReady.bind(this))
        } else {
          this.setState(state)
        }
      }

      if (hold)
        this._streamOnValue(s.map(merge({__ready: true})), onValue.bind(this))
      else
        this._streamOnValue(s, onValue.bind(this))
    }
  }

  _streamOnValue(stream, fn, errorFn) {
    this._observeStreams.push(stream.onValue(fn))
    if (errorFn)
      this._observeStreams.push(stream.onError(errorFn))
  }


  componentWillUnmount() {
    this._cleanupStreams()
  }

  _cleanupStreams() {
    map(call, this._observeStreams)
    this._observeStreams = []
  }

  render() {
    if (this.state && this.state.__ready)
      return this.renderStreams()
    else
      return this.renderLoading()
  }

  renderLoading() {
    return null
  }
}

export const convertError = curry((converter, value) =>
  new Bacon.Error(converter(value))
)